// 모바일 디바이스 감지 유틸리티

// 화면 크기를 기반으로 모바일인지 판단
export const isMobileByScreenSize = () => {
  return window.innerWidth <= 768;
};

// User Agent를 기반으로 모바일인지 판단
export const isMobileByUserAgent = () => {
  const userAgent = navigator.userAgent.toLowerCase();
  const mobileKeywords = [
    'mobile', 'android', 'iphone', 'ipad', 'ipod', 'blackberry', 
    'windows phone', 'opera mini', 'mobile', 'tablet'
  ];
  
  return mobileKeywords.some(keyword => userAgent.includes(keyword));
};

// 터치 지원 여부 확인
export const isTouchDevice = () => {
  return 'ontouchstart' in window || navigator.maxTouchPoints > 0;
};

// 종합적인 모바일 감지 (화면 크기 + User Agent + 터치 지원)
export const isMobileDevice = () => {
  const screenSize = isMobileByScreenSize();
  const userAgent = isMobileByUserAgent();
  const touchSupport = isTouchDevice();
  
  // 화면 크기가 모바일이거나, (User Agent가 모바일이고 터치를 지원하는 경우)
  return screenSize || (userAgent && touchSupport);
};

// 반응형 리스너 (리사이즈 이벤트용)
export const addMobileDetectionListener = (callback) => {
  const handleResize = () => {
    callback(isMobileDevice());
  };
  
  window.addEventListener('resize', handleResize);
  
  // 초기 호출
  callback(isMobileDevice());
  
  // 클린업 함수 반환
  return () => {
    window.removeEventListener('resize', handleResize);
  };
};

// 디바이스 타입 상세 정보
export const getDeviceType = () => {
  const width = window.innerWidth;
  
  if (width <= 360) return 'small-mobile';
  if (width <= 480) return 'mobile';
  if (width <= 768) return 'tablet';
  if (width <= 1024) return 'tablet-landscape';
  return 'desktop';
}; 